import { render, staticRenderFns } from "./CreateCampaign.vue?vue&type=template&id=3fb47711"
import script from "./CreateCampaign.vue?vue&type=script&lang=js"
export * from "./CreateCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports